import ReactApexChart from "react-apexcharts";

function TopTreks({ topTreks = [], showToolbar = true }) {
  const trekData = topTreks;

  return (
   <ReactApexChart
  options={{
    chart: {
      type: "bar",
      height: 200,
      fontFamily: "Inter, sans-serif",
      toolbar: {
        show: showToolbar,
      },
    },
    plotOptions: {
      bar: {
        horizontal: true,
        borderRadius: 4,
        barHeight: "60%",
      },
    },

    // Categories should be here
    xaxis: {
      categories: trekData.map((trek) => trek.name),
      labels: {
        show: true,
        style: {
          colors: "#111827",
          fontSize: "12px",
          fontWeight: 500,
        },
      },
    },

    // Remove categories from yaxis
    yaxis: {
      labels: {
        show: true,
      },
    },

    colors: ["#FFA07A"],

    dataLabels: {
      enabled: true,
      formatter: (val) => val,
    },

    grid: {
      show: false,
    },

    tooltip: {
      enabled: true,
    },
  }}
  series={[
    {
      name: "Treks",
      data: trekData.map((trek) => trek.count),
    },
  ]}
  type="bar"
  height={250}
/>
  );
}

export default TopTreks;